(() => {
  const init = root => root.querySelectorAll('[data-pp-how-dialog]').forEach(dialog => {
    if (dialog.dataset.ready || typeof dialog.showModal !== 'function') return;
    dialog.dataset.ready = 'true';
    const stage = dialog.querySelector('[data-pp-how-stage]');
    const closeButton = dialog.querySelector('[data-pp-how-close]');
    let activeVideo;
    let originalParent;
    let originalNext;
    let opener;
    let scrollPosition;
    let bodyStyles;
    let backdropPressed = false;
    const isBackdrop = target => target === dialog || target === stage;
    const ratioOf = video => Number(video.dataset.ppHowRatio ||= video.closest('[data-pp-how-ratio]')?.dataset.ppHowRatio || '') || 1;
    const fitVideo = () => stage.style.setProperty('--sap-how-video-ratio', activeVideo?.videoWidth && activeVideo.videoHeight ? activeVideo.videoWidth / activeVideo.videoHeight : activeVideo ? ratioOf(activeVideo) : 1);
    dialog.closest('.shopify-section').querySelectorAll('.x1-top .x1-more').forEach(details => {
      const video = details.querySelector(':scope > video');
      const summary = details.querySelector(':scope > summary');
      if (!video || !summary) return;
      video.addEventListener('loadedmetadata', () => { if (activeVideo === video) fitVideo(); });
      summary.setAttribute('aria-haspopup', 'dialog');
      summary.setAttribute('aria-controls', dialog.id);
      summary.addEventListener('click', event => {
        event.preventDefault();
        if (dialog.open) return;
        opener = summary;
        activeVideo = video;
        fitVideo();
        originalParent = video.parentNode;
        originalNext = video.nextSibling;
        scrollPosition = { top: window.scrollY, left: window.scrollX, behavior: 'instant' };
        bodyStyles = ['position', 'top', 'left', 'right', 'overflow'].map(property => [property, document.body.style.getPropertyValue(property), document.body.style.getPropertyPriority(property)]);
        video.pause();
        video.removeAttribute('autoplay');
        video.playsInline = true;
        video.setAttribute('aria-label', summary.textContent.trim());
        stage.append(video);
        details.open = false;
        Object.assign(document.body.style, { position: 'fixed', top: '-' + scrollPosition.top + 'px', left: '0', right: '0', overflow: 'hidden' });
        dialog.setAttribute('aria-label', summary.textContent.trim());
        dialog.showModal();
        closeButton.focus({ preventScroll: true });
        video.play().then(() => { if (!dialog.open || activeVideo !== video) video.pause(); }).catch(() => {});
      });
    });
    closeButton.addEventListener('click', () => dialog.close());
    dialog.addEventListener('pointerdown', event => { backdropPressed = isBackdrop(event.target); });
    dialog.addEventListener('click', event => {
      if (backdropPressed && isBackdrop(event.target)) dialog.close();
      backdropPressed = false;
    });
    dialog.addEventListener('close', () => {
      activeVideo?.pause();
      if (activeVideo && originalParent) originalParent.insertBefore(activeVideo, originalNext);
      activeVideo = null;
      bodyStyles?.forEach(([property, value, priority]) => value ? document.body.style.setProperty(property, value, priority) : document.body.style.removeProperty(property));
      if (scrollPosition) window.scrollTo(scrollPosition);
      opener?.focus({ preventScroll: true });
    });
  });
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
